module.exports = __webpack_public_path__ + "img/GF.68baa579.svg";